var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconideation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_158_286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19.9996V5.99956C24 5.20392 23.6839 4.44085 23.1213 3.87824C22.5587 3.31564 21.7956 2.99956 21 2.99956H20C19.9999 2.53529 19.8921 2.07737 19.6849 1.66185C19.4778 1.24634 19.1771 0.88456 18.8064 0.605002C18.4357 0.325445 18.0052 0.135735 17.5488 0.0508051C17.0923 -0.0341247 16.6224 -0.0119566 16.176 0.115565L13.176 0.973565C12.7394 1.09843 12.3372 1.32145 12 1.62556C11.6628 1.32145 11.2606 1.09843 10.824 0.973565L7.824 0.115565C7.37758 -0.0119566 6.90765 -0.0341247 6.45121 0.0508051C5.99477 0.135735 5.56427 0.325445 5.19359 0.605002C4.82292 0.88456 4.52218 1.24634 4.31507 1.66185C4.10795 2.07737 4.0001 2.53529 4 2.99956H3C2.20435 2.99956 1.44129 3.31564 0.87868 3.87824C0.31607 4.44085 0 5.20392 0 5.99956L0 19.9996H11V21.9996H7V23.9996H17V21.9996H13V19.9996H24ZM13 3.85756C13.0001 3.64038 13.0709 3.42913 13.2017 3.25575C13.3325 3.08237 13.5162 2.95629 13.725 2.89656L16.725 2.03956C16.8144 2.01369 16.9069 2.00023 17 1.99956C17.2652 1.99956 17.5196 2.10492 17.7071 2.29246C17.8946 2.47999 18 2.73435 18 2.99956V9.24557L13 10.6736V3.85756ZM6 2.99956C6.00022 2.84488 6.03633 2.69236 6.10547 2.55399C6.17462 2.41562 6.27492 2.29518 6.3985 2.20214C6.52207 2.1091 6.66554 2.04599 6.81763 2.01778C6.96972 1.98957 7.12628 1.99703 7.275 2.03956L10.275 2.89656C10.4838 2.95629 10.6675 3.08237 10.7983 3.25575C10.9291 3.42913 10.9999 3.64038 11 3.85756V10.6736L6 9.24557V2.99956ZM2 5.99956C2 5.73435 2.10536 5.47999 2.29289 5.29246C2.48043 5.10492 2.73478 4.99956 3 4.99956H4V10.7536L12 13.0396L20 10.7536V4.99956H21C21.2652 4.99956 21.5196 5.10492 21.7071 5.29246C21.8946 5.47999 22 5.73435 22 5.99956V17.9996H2V5.99956Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_158_286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconideation);
export default __webpack_public_path__ + "static/media/icon=ideation.7874afee6a48e2e06f01d323d0939f0c.svg";
export { ForwardRef as ReactComponent };